import { ForgotPasswordForm } from '@/components'
import { Footer } from '@/components/nav/Footer'

export function ForgotPasswordPage() {
    return (
        <>
            <section className="bg-gray-50 dark:bg-gray-900">
                <ForgotPasswordForm />
            </section>
            <Footer />
        </>
    )
}
